import React from 'react'
import { QueryClientProvider } from '@tanstack/react-query'

import { deliveryPerformanceQueryClient } from 'queryClients/deliveryPerformance'

import { useDeliveryPerformanceListController } from './hooks/useDeliveryPerformanceListController'
import { useWarehouseSelection } from './hooks/useWarehouseSelection'
import { DeliveryPerformanceListHeader } from './components/DeliveryPerformanceListHeader'
import { DeliveryPerformanceListView } from './components/DeliveryPerformanceListView'

// 倉庫/テナント選択と一覧取得で同じ tenantId を共有するため、両 hook を本コンポーネントで合成する。
const DeliveryPerformanceListInner: React.FC = () => {
  const {
    warehouseId,
    tenantId,
    warehouseOptions,
    tenantOptions,
    changeWarehouseId,
    changeTenantId,
  } = useWarehouseSelection()

  const controller = useDeliveryPerformanceListController({ tenantId })

  return (
    <>
      <DeliveryPerformanceListHeader
        warehouseId={warehouseId}
        tenantId={tenantId}
        warehouseOptions={warehouseOptions}
        tenantOptions={tenantOptions}
        changeWarehouseId={changeWarehouseId}
        changeTenantId={changeTenantId}
      />
      <DeliveryPerformanceListView {...controller} />
    </>
  )
}

export const DeliveryPerformanceListPage: React.FC = () => (
  <QueryClientProvider client={deliveryPerformanceQueryClient}>
    <DeliveryPerformanceListInner />
  </QueryClientProvider>
)
